import { useQuery, useMutation, useQueryClient } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

const fetchFlight = async (id: string) => {
  const res = await fetch(`${API_URL}/flights/${id}`, {
    credentials: "include",
  });
  // TODO: process error
  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useGetFlight = (id: string) => {
  const navigate = useNavigate();

  return useQuery(["flight", id], () => fetchFlight(id), {
    refetchOnWindowFocus: false,
    retry: 1,
    onError: (error: Error) => {
      if (error.message === "401") {
        clearStoredAuth();
        navigate("/");
      }
    },
  });
};

const deleteFlight = async (id: string) => {
  const res = await fetch(`${API_URL}/flights/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useDeleteFlight = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(deleteFlight, {
    onSuccess: () => {
      queryClient.invalidateQueries('flights');
      navigate('/');
    },
    onError: (error: Error) => {
      if (error.message === '401') {
        clearStoredAuth();
        navigate('/');
      }
    },
  });
};

const requestFlightLeonRetransfer = async (id: string) => {
  const res = await fetch(`${API_URL}/flights/${id}/leon-retransfer`, {
    method: "POST",
    credentials: "include",
  });

  if (!res.ok) {
    let message = `${res.status}`;
    try {
      const payload = await res.json();
      message = payload?.message || payload?.text || message;
    } catch (_error) {
      // Keep the status code when the server does not return JSON.
    }
    throw new Error(message);
  }

  return res.json();
};

export const useFlightLeonRetransfer = () => {
  return useMutation(requestFlightLeonRetransfer);
};
